import { computeHealthBoxBorderColor } from './utils';
const statusPriority = {
  GATEWAY: 1,
  ACCESS_POINT: 2,
  LOCATION: 3
};
class Serializer {
  normalize = data => {
    return {
      healthStatusCount: data.healthStatusCount,
      totalCount: data.totalCount,
      assetType: data.assetType,
      statusPriority: data.assetType && statusPriority[data.assetType],
      borderColor: data.healthStatusCount && computeHealthBoxBorderColor(data.healthStatusCount)
    };
  };
}

export const StatusSummarySerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/status/index.js